<!-- <div class="modal__description m-b-xs-medium m-b-lg-regular font-xs-regular font-lg-medium-big font-color-gray font-weight-bold">Enter the information below to view loan offers through iCreditWorks</div> -->
<div class="modal__main">
    <div class="main__leftpart">
        <div class="leftpart__image leftpart__image_big">
            <img [src]="sharedDataService.assetsCdn('images/dent-and-pony.jpg')"alt="" loading="lazy">
        </div>
    </div>
    <div class="main__rightpart">

        <div class="rightpart__header rightpart__header_bg-orange header-smaller">Adjusted Loan Offer</div>
        <div class="rightpart__wrapper border-gray">
            <div class="doWhite main__rightpart_sory-gray-block">
                <div class="invImgDiv">
                    <img id="imgLeft" [src]="sharedDataService.assetsCdn('images/partial-approved.png')" alt="" loading="lazy">
                </div>

                <div class="adjLA contact-paragraph font-lg-big d-xs-none">Adjusted Loan Amount</div>
                <div class="adjLA contact-paragraph font-lg-big d-xs-flex">Adjusted Loan Amount</div>

                <div class="loanAmountDiv flex-row a-items-center header-extra-large">
                    <span class="dollarSign header-xs-large header-lg-small m-r-regular">$</span>{{transformLoanAmountWithCommas(approvedLoanAmount)}}
                </div>

                <div class="adjDesc contact-paragraph font-lg-big d-xs-none">This loan amount is less than <br> your original request of {{ '$' + transformLoanAmountWithCommas(loanAmount) }}. </div>
                <div class="adjDesc contact-paragraph font-lg-big d-xs-flex">This loan amount is less than <br> your original request of {{ '$' + transformLoanAmountWithCommas(loanAmount) }}. </div>

                <div id="goToSelectBtn" (click)="goToSelectLoan()" class="btn btn-size_normal btn-primary font-lg-medium-big m-x-auto">Loan Options</div>
            </div>
        </div>
    </div>
</div>